import { request, requestFd } from '@/common/request';
import { AxiosRequestConfig } from 'axios';

const prefix = '/uaa/user';

export const switchChain = (id: string, config?: any) =>
  request.put(
    `${prefix}/switchOrganize/${id}`,
    {},
    {
      headers: {
        Authorization: config.token,
      },
    },
  );

export const httpGetCaptcha = (params: any) => request.post('/uaa/captcha/action', params);
export const httpVerifyCaptcha = (params: any) => request.post('/uaa/captcha/action/check', params);

/**
 * 扫码登录-获取二维码
 * @param url 应用授权页面地址
 * @returns
 */
export const httpBuildQrConnectUrl = (callbackUrl: any) => {
  let url = `/uaa/thirdPartyAuth/wechat/buildQrConnectUrl?authPage=${callbackUrl}`;
  url = url.replace('#', '%23'); // decodeUrl不会处理#号，手动处理
  return request.get(url);
};

/**
 * 扫码登录-绑定手机
 * @param url 应用授权页面地址
 * @returns
 */
export const httpAddWechatPassport = (
  params: { appId: string; openId: string; channel: string; unionId: string },
  config?: any,
) =>
  request.post('/uaa/user/addWechatPassport', params, {
    headers: {
      Authorization: config.token,
    },
  });

/**
 * 扫码登录-构建企业微信Web登录授权链接
 * @param url 应用授权页面地址
 * @returns
 */
export const httpBuildworkQrCodeUrl = (callbackUrl: any) => {
  let url = `/uaa/thirdPartyAuth/wechat/work/buildWebLoginUrl?authPage=${callbackUrl}`;
  url = url.replace('#', '%23'); // decodeUrl不会处理#号，手动处理
  return request.get(url);
};

/**
 * 登录
 * @param params 参数
 * @param config
 * @returns
 */
export const doLogin = (params: any, config: AxiosRequestConfig = {}) =>
  requestFd.post('/uaa/sso/doLogin', params, config);

/**
 * 获取验证码
 * @param phoneNo 手机号码
 * @param resetPwd 是否为重置密码
 * @returns
 */
export const sendPhoneCode = (phoneNo: string, resetPwd = false) =>
  request.post('/uaa/captcha/sms', {
    phone: phoneNo,
    resetPwd,
  });

export const getListOrganize = (params: any, config?: any) => {
  return request.post(`${prefix}/listOrganize`, params, {
    headers: {
      Authorization: config.token,
    },
  });
};

export const httpListUserOrganize = (config?: any) => {
  return request.get('uaa/user/listUserOrganize', {
    headers: {
      Authorization: config.token,
    },
  });
};

/**
 * 用户重置密码
 * @param id
 * @returns
 */
export const userResetPassword = (params: any, config?: any) => {
  return request.post<any, any>('/uaa/user/resetPassword', params, {
    headers: {
      Authorization: config.token,
    },
  });
};
